import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSun = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 3v1.372m0 15.256V21m9-9h-1.372M4.372 12H3m15.364-6.364-.97.97M6.606 17.394l-.97.97m12.728 0-.97-.97M6.606 6.606l-.97-.97"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 7.805a4.195 4.195 0 1 1 0 8.39 4.195 4.195 0 0 1 0-8.39"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSun);
export default ForwardRef;
